let projects = [
  {
    Timestamp: "9/3/2023 4:00:37",
    projectName: "SemaphoreDao",
    tagline:
      "Create entry restricted DataDaos with the help of Semaphores and SpruceID",
    description:
      "Now-a-days Daos are open to users and there is no strict entry gated DAOs where in the DAO members feels a need to have an exclusive group chat with their members. Hence this can be solved by create an entry resstriction to the DAO ( such as user must have specific number of commits before joining the DAO) and their identity are generated by the ethereum public address by signing a message which generates the publickey and that public key generates the identity of the user using semaphores which is then stored on chain",
    ethereumAddress: "0xe872aB4c7e41eE9CDa5E45D73Fc53a6108f0aedE",
    website: "https://github.com/KENILSHAHH/ETHCON-Korea",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1njyjNb77Q_88Fn_ac_-BWKC9sBKK2hCx",
    logoCdnUrl:
      "https://drive.google.com/open?id=16einOmXIIVagpW-_8eLiTVmYt4-BGGDX",
    bannerImageLink:
      "https://drive.google.com/open?id=1RYFb1YeSQuT3BS0uO125VFsOgDJ5mEqd",
    id: "1",
    recipientId: 1,
  },
  {
    Timestamp: "9/3/2023 6:05:56",
    projectName: "ChainBreaker",
    tagline: "Record and unchain debt chains with blockchain",
    description:
      '\nImagine if you could potentially alleviate the financial burdens of millions of people of millions of $ with just one small transaction. Our mobile web application consists of two primary entities: Clients and "Circuit Builders", or just "Builders".\n\nClients use the app to record their debts and the dynamic movements of these debts. On the other hand, Builders are entities who identify closed circuits of client debts and work towards freeing users from the chain by eliminating the smallest debt relation. Builders get tips from the Clients for this and also mint NFT as an incentive.\n\nTo put it simply, consider a scenario where person A owes person B $10, person B owes person C $10, and person C owes person A $10. In this case, they can collectively agree that nobody owes anything to anyone. 30$ debt reduced to 0$ debt. In the case the debts are not the same, every single debt is reduced by the smallest amount and one of the users is freed from that chain. While this concept is straightforward with just three people, it becomes increasingly complex to identify such circuits with tens, thousands, or even millions of individuals involved. Only a secure, tamper-proof, transparent, and decentralized network can effectively uncover and help address such intricate debt circuits.',
    ethereumAddress: "0xDaFD7e67664A118Fb2F7F130AE6E58A7588798cA",
    website: "https://github.com/gylman/ChainBreaker",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1dm00SXpng-qksWLE7ELlZZU4yXYeXnD_",
    logoCdnUrl:
      "https://drive.google.com/open?id=1C-DtharpvXRxk7CXaG65CbsHQiTO8xM7",
    bannerImageLink:
      "https://drive.google.com/open?id=1x5mlqplOXv9VIRzFqt5ynJix3jjjdKLf",
    id: "2",
    recipientId: 2,
  },
  {
    Timestamp: "9/3/2023 7:10:06",
    projectName: "DECOHACKS(Decentralization Of HACKathonS)",
    tagline:
      "DECOHACKS is a decentralized hackathon platform crafted by seasoned hackathon enthusiasts. Addressing the operational pitfalls of Web3 hackathons, it leverages various L2 chains and Semaphore to ensure transparent and efficient management.",
    description:
      "The Senshilabs team, creators of DECOHACKS, participated in numerous hackathons over the years as hackathon geeks and consistently questioned the efficiency of their operations. They identified that Web3 based hackathons were still being managed on Web2 platforms. Processes like prize disbursements, which could be efficiently replaced with smart contracts, were still wasting unnecessary manpower and resources. With these issues in mind, DECOHACKS emerged as a solution in the form of a decentralized hackathon platform. By integrating various L2 chains and the Semaphore technology, this platform aims to significantly enhance the transparency, security, and accessibility of hackathon operations.",
    ethereumAddress: "0xCEe592359C4673d90921BbFD6bF46674FD890f16",
    website: "https://github.com/senshilabs/decohacks-proto",
    thumbnailImageLink:
      "https://drive.google.com/open?id=13BWDN-5rl3tlndBSmpU6AbB_acuMS0l5",
    logoCdnUrl:
      "https://drive.google.com/open?id=1VlS4yrpY38YFW6cKkVV_OZrEWwKQBayV",
    bannerImageLink:
      "https://drive.google.com/open?id=1WyL2PxV2zur2hUuK-CPmSV_QI-7BywZ8",
    id: "3",
    recipientId: 3,
  },
  {
    Timestamp: "9/3/2023 12:08:17",
    projectName: "Traffle",
    tagline: "Fair and Simple NFT Raffle Platform",
    description:
      "Start a raffle with your NFT. The winner is fairly picked by Chainlink VRF.\nBest way to liquidate NFT under a day, and also giving chance of winning NFTs at <1% of price!",
    ethereumAddress: "0x0A642B39595782FbeC9C75202eE6248E51008933",
    website: "https://traffle.tracerofficial.com/",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1QejOVV_AHHz-rEbrYRtwEvnN9EmLhqUx",
    logoCdnUrl:
      "https://drive.google.com/open?id=1qghHQ9F4wd_92sElLRt5QneHPOXkQl8e",
    bannerImageLink:
      "https://drive.google.com/open?id=126zqlEC05VzieORg5n2x4Qpr5o6Iy4kf",
    id: "5",
    recipientId: 5,
  },
  {
    Timestamp: "9/3/2023 12:24:06",
    projectName: "Hookbreaker",
    tagline: "Accurate Phishing/Scam Website Detection",
    description:
      "Hookbreaker is a Chrome extension that analyzes a site of your choosing for signs of phishing. It uses Indicators of Attack (IoAs), known patterns of phishing websites, to check if the site you are viewing is likely a scam.\n\nHookbreaker does more than existing anti-phishing extensions, as it analyzes HTML content and external script links, not just the website\u2019s domain (which it does too). The extension only checks the current tab\u2019s site if you click the extension\u2019s icon, preserving privacy for websites that you are comfortable with.",
    ethereumAddress: "0xd1fFdA9C225DDEE34f0837BF4D4a441bDd54C473",
    website: "https://github.com/d0wnlore/hookbreaker",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1oZVSzEw9jH2A7uELCNT8H_KQiGNUVFVt",
    logoCdnUrl:
      "https://drive.google.com/open?id=1I1InJ0kXgEibUtzhgVOZnU9qcFNrszrg",
    bannerImageLink:
      "https://drive.google.com/open?id=1t-HUn0WCmrCXl_bREyHOYbn6G1DnjLKp",
    id: "6",
    recipientId: 6,
  },
  {
    Timestamp: "9/3/2023 12:24:21",
    projectName: "ZK-mask",
    tagline:
      "Our project is getting personal facial scores by third parties using zk technology. Users could upload their picture for rating, wait for a certain epoch, and the score is finalized and written in ID.",
    description:
      "Our project is getting personal facial scores by third parties with zk-encrypted. Scoring method is held by decentralized and zk-secured way using UniRep built upon pse-Semaphore. When users upload their picture for rating, they should wait for certain epoch and gets finalized facial score. For use case, this could be used in dating chat application. In this situation, people could only enter the chatting room only if they meet specific scoring criteria which is guaranteed by ZK-proof.",
    ethereumAddress: "0x035c628c9b835B22Da9a2Dd09d6f81691F4DC946",
    website: "https://github.com/2023-Ethcon-jellybelly-zkMask",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1FZN91Xwng9huDuCWY8uFN_0nVqUaj9nd",
    logoCdnUrl:
      "https://drive.google.com/open?id=1aoy-Db00tN7ORiOndAy39x-L-tG1pXqz",
    bannerImageLink:
      "https://drive.google.com/open?id=1cmHneE1WTQzXm96ZREcerRKXEmdcN4at",
    id: "7",
    recipientId: 7,
  },
  {
    Timestamp: "9/3/2023 12:34:26",
    projectName: "NFT Saka",
    tagline:
      "You can customize the image and mint your NFT on the OP network, then bridge the minted NFT between the OP and ETH networks.",
    description:
      "While there are services available for bridging ERC-20 tokens, there is currently a lack of solutions for bridging ERC-721 tokens between the OP and ETH networks. Saka NFT offers a solution to bridge your ERC-721 tokens seamlessly between the OP and ETH networks.",
    ethereumAddress: "0x6eF61b3715c3Fa3483340C6d0f44a4CECD96A540",
    website: "https://github.com/TralaTomJeong/Ethcon2023",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1OW3YZUBRHbdCHkYOf6iM0BYODoSbd66h",
    logoCdnUrl:
      "https://drive.google.com/open?id=1VlDTLoirV5yH4Mq7dpeH7-v0f9ychF0O",
    bannerImageLink:
      "https://drive.google.com/open?id=1RnvNC4ABq3KCjTo0t0AQ6V3CjgdXPr60",
    id: "8",
    recipientId: 8,
  },
  {
    Timestamp: "9/3/2023 12:34:26",
    projectName: "torch2circom",
    tagline: "Translating pytorch model to circom circuits",
    description:
      "Our project is to make bridge between ML and ZK, by giving efficient tools for ML developers to bring ZK features. We present torch2circom, which automatically translate pytorch model to circom circuits.",
    ethereumAddress: "0x4036Ac48099e9B4685ecAdbD2A43874d5608aBE9",
    website: "https://github.com/torch2circom",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1IGp4T6TUJDWgfrh-BNqVoknmysmtgZHu",
    logoCdnUrl:
      "https://drive.google.com/open?id=1fXusNE9OR7VKF8tBP6e-FrLvOO5ZCEhH",
    bannerImageLink:
      "https://drive.google.com/open?id=1cuh3Pgue83mz7ae1orzmK3RyF07VvCOf",
    id: "9",
    recipientId: 9,
  },
  {
    Timestamp: "9/3/2023 13:06:00",
    projectName: "Paylink",
    tagline:
      "Paylink allows you to send a crypto payment to anyone with just a link.",
    description:
      "Paylink is a revolutionary tool that simplifies Web3 payments across multiple blockchains, not just Ethereum. Utilizing a multichain approach, we enable users to send and receive payments effortlessly through a simple link. What sets Paylink apart is our innovative use of account abstraction, making it exceptionally easy for recipients to claim their funds. This user-friendly interface lowers barriers to entry, making Web3 and decentralized finance (DeFi) accessible to a wider audience. Paylink contributes to the growth of blockchain ecosystems by driving user adoption, expanding use cases, fostering community engagement, and enhancing the overall experience",
    ethereumAddress: "0xE27FBA2d264b8a12315b447d17d69a06FbaB3F90",
    website: "https://github.com/EthCon2023",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1KUocqDvwCWvycdG0GJfIQskj3udEbMLk",
    logoCdnUrl:
      "https://drive.google.com/open?id=1OFt_CGMqOfw7pPkR_cnLLXXgD4ylkD1K",
    bannerImageLink:
      "https://drive.google.com/open?id=1O476o4jd4DazV9D-oW8awbWCCTLCo-II",
    id: "10",
    recipientId: 10,
  },
  {
    Timestamp: "9/3/2023 13:07:35",
    projectName: "Careerzen",
    tagline: "Business networking platform based on Career NFT",
    description:
      "Careerzen is a business networking service based on NFT profile representing user's career such as education, skills and awards etc by owning each career NFTs.",
    ethereumAddress: "0x68BEeB607B96A7C5D177F58C74d593d654f71705",
    website: "https://github.com/orgs/Careerzenn/repositories",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1EYJPAhUhF2gy2jjOJ8ysCBk5_f5UkU6m",
    logoCdnUrl:
      "https://drive.google.com/open?id=1IG-pMDFfjHzo0-Su6GZZdofFHKi-VT18",
    bannerImageLink:
      "https://drive.google.com/open?id=1pq8yfzIxgsvYosympgRQ_dSpSzWLsCU7",
    id: "11",
    recipientId: 11,
  },
  {
    Timestamp: "9/3/2023 12:48:18",
    projectName: "Loanster",
    tagline:
      "Leverage or Hedge UniswapV3 based positions using Lending Protocols(Spark, AAVE, LineaBank) to maximize profits and mitigate Impermanent Loss and enjoy a super smooth UX in a single application.",
    description:
      "DeFi is one of the main pillars of the Ethereum Ecosystem. Uniswap V3, although being one of the most popular DeFi protocol, has major problems for lp providers. Loanster aims to solve the main problems these problems and give a better DeFi experience to LP providers. \n\nWhile Uniswap V3 addressed issues like wasted liquidity and price impacts through concentrated liquidity, it introduced a higher risk of impermanent loss for liquidity providers. In fact, over 50% of liquidity providers experience impermanent losses due to price fluctuations. \n\nFor example, in the case of investing in ETH+DAI position, if the ETH price goes up and the current price tick goes out of range, your position will change to 0% ETH and 100% DAI. In this case, you cannot gain any profit from the increase of the ETH price. Conversely, if ETH price drops, and your position changes to 100% ETH and 0% DAI, you will take all the losses directly. \n\nSo, Uniswap V3 can only profit in crab markets, when the price is stable and stays in a certain price range. In order to diversify our strategies, and be able to profit in bear or bull markets, we integrated the lending protocol in order to mitigate the impermanent losses. In a bullish market, we borrow DAI and deposit ETH as collateral. This way, we can take the benefits of the increase in the ETH price and still earn LP fees, maximizing our profits in the long strategy. In the bearish market, we do the exact opposite, by borrowing ETH and depositing DAI as collateral. Depending on the anticipated LP fees and anticipated price change, users could optimize profits by adjusting the borrowing rate.\n\nAlso, Uniswap V3 has a complex UX for preparing the exact amount of assets to add as liquidity for their position. Once they swap their assets in the pool, the ratio of their position will also change, so it is very difficult to put all of your desired assets into your position.\nLoanster solved this problem using the Loanster Contract, which calculates the exact amount to swap and add as liquidity for your position. \n\nAlso, defi infrastructures such as swaps and bridges are scattered, so you need to navigate through many different dApp pages. Loanster also aggregated these infrastructures and abstracted the complex process. It calculates the route for you, and all you need to do is press approve on a single page, and you\u2019re done investing! To summarize it all, people can enjoy a smooth UX and enjoy various investment strategies on a single page!",
    ethereumAddress: "0xAA289325d1afc4AA040281b10dD9f10A8560D296",
    website: "https://github.com/swimmiee/ethcon-korea-loanster/tree/main",
    thumbnailImageLink:
      "https://drive.google.com/open?id=19QofPp_GKy_JMKoRjDZOvFpwyyPKmzib",
    logoCdnUrl:
      "https://drive.google.com/open?id=1u1Tp3BvHKzLdMCLuopn1dy1K18afJuHW",
    bannerImageLink:
      "https://drive.google.com/open?id=1p8UZKCyZmHYv53Wg-d6R-SKGhfNi37BW",
    id: "12",
    recipientId: 12,
  },
  {
    Timestamp: "9/3/2023 12:51:33",
    projectName: "Chain Concierge",
    tagline:
      "Your personal AI assistant summarizes governance proposal requests for each protocol",
    description:
      "Keep track of all the governance proposals that come up on DAOs with our Chain Reporter, which summarizes the key points of the proposals in an instant. You can publish this as a newsletter by linking it to your Gmail account, Slack, or Discord.",
    ethereumAddress: "0xb89C33bE71c2aAd77d6712b1AD47274aD9fb7dcb",
    website: "https://github.com/joyjsmun/chain-concierge",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1tOc2dlvaWB1MjGIXy1mf9DcuPJUkiCJI",
    logoCdnUrl:
      "https://drive.google.com/open?id=1CzO_IAof1o7SV-X4CD2zL2mPBEv-A8l_",
    bannerImageLink:
      "https://drive.google.com/open?id=18fNGhpA2JUgpBbr3Ytc3BPbq94RWiVV1",
    id: "13",
    recipientId: 13,
  },
  {
    Timestamp: "9/3/2023 12:56:10",
    projectName: "RIC Rolling",
    tagline:
      "The first rollup-as-a-service platform operated entirely via smart contract. Never gonna rug you up!",
    description:
      "Current rollup-as-a-service providers are fully centralised. If they misbehave (by censoring transactions, extracting MEV, or simply interrupting service), there is no recourse for users besides going to court.\nWith our smart contract approach, providers are paid for service provided, and owners (this could be a DAO) remain in control.\nIt's almost as if we could replace paper contracts with smart contracts!",
    ethereumAddress: "0x2491DbD3C7B198bafbbc3520D048460dF9a61426",
    website: "https://github.com/ricrolling",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1pmoWL-PGh6U1LIZ8_gavam3mjsmFb0wp",
    logoCdnUrl:
      "https://drive.google.com/open?id=1LiYEIX2gI7C1hTn6NJQYexgq2HOZFDLq",
    bannerImageLink:
      "https://drive.google.com/open?id=1MPZMTo_6M90_sGIDs69WfAk9XX-1PB6W",
    id: "14",
    recipientId: 14,
  },
  {
    Timestamp: "9/3/2023 12:57:45",
    projectName: "Daskalos - \ub2e4\uc2a4\uce7c\ub85c\uc2a4 ",
    tagline:
      "Daskalos: An interactive playground for transaction validation, offering Web2 developers a no-code, concept-driven learning experience through incremental gameplay.",
    description:
      "With the increasing shift towards Web3, a growing number of Web2 developers are transitioning into the Web3 development ecosystem. Yet, many encounter difficulties in fully understanding Web3 concepts, often resulting in less optimal implementations.\n\nThere's a clear gap between purely theoretical resources that explain Web3 technology and hands-on coding exercises. Addressing this need, Daskalos - \ub2e4\uc2a4\uce7c\ub85c\uc2a4, inspired by the god of education, offers an interactive, game-based playground. This approach, focusing on a no-code learning experience, begins with basic concepts and gradually introduces more intricate systems. The platform's primary aim is to immerse Web2 developers in an experiential understanding of Web3 operations, moving beyond mere definitions or abstract explanations. By doing so, we hope to streamline their transition into Web3 development. Furthermore, as an open-source and free platform, Daskalos ensures accessibility, promoting inclusivity and reaching a diverse audience, regardless of financial barriers.",
    ethereumAddress: "0x7fBCBd701E1c97aF4aac4248B9F13a661bCFb392",
    website: "https://github.com/selimerunkut/ethkorea_jinjang_team_repo",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1R-Q8cIsk7bhEyLPM36qgU3oHFxnbNH3s",
    logoCdnUrl:
      "https://drive.google.com/open?id=1zeG5h9Orl5rLVZ9ZqrzR_pZkxqmDPDv3",
    bannerImageLink:
      "https://drive.google.com/open?id=1A6ulgf77dx6T2hTrvsiQhpyq2AUgOv_w",
    id: "15",
    recipientId: 15,
  },
  {
    Timestamp: "9/3/2023 13:08:01",
    projectName: "IDEN",
    tagline:
      "IDEN is a mutual voting system designed to help you discover your identity. The goal of IDEN is to evolve into the Identity Layer of Ethereum and set a new standard for identities of web.",
    description:
      'IDEN solves the issue in traditional social media where people only show a curated version of themselves, without really knowing how others perceive them. On platforms like Instagram, people create the image they want to portray to others. However, they cannot know how they are actually perceived by others.\nIn IDEN, information about how others view you is continually conveyed through voting. In IDEN app, users are presented with questions about others, such as "Who among these people is the best listener?" along with a list of people they know as options. Users then vote for the person who they think best fits the criteria of the question. Each vote is recorded in individual SBTs (Subjective Blockchain Tokens), and the accumulated voting data is summarized by AI NLP model to dynamically update a single Identity SBT. In this Identity SBT, every user has a summary of their personality evaluted by other users. Through this, users can have fun recording how they actually feel about others, and also hear what other people think about them.',
    ethereumAddress: "0xD29Df18c8bF98e2cf50376551da68507bf63fF1B",
    website: "https://github.com/orgs/ethcon-iden/repositories",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1cIwmTMSu80NgJPvIuzd-W9YTOemZzEad",
    logoCdnUrl:
      "https://drive.google.com/open?id=1KkJBZBxJ6kApJDUVa3-O-_vBTi-9ebRn",
    bannerImageLink:
      "https://drive.google.com/open?id=1PSWXr5940h64Ycwv38o9uMh60rLbBUwb",
    id: "16",
    recipientId: 16,
  },
  {
    Timestamp: "9/3/2023 11:50:25",
    projectName: "Multichain Mutation Dino",
    tagline:
      "Mint chain specific generative art with a chain specific prompt addition that allows multi-chain unique generative NFT mints with one tx! ",
    description:
      "NFT minting is single chain, NFT bridges are boring and constrained by their multisig designs, wrapped versions, and just an overall dull experience for the multi-chain explorer.\n\nWe create a new consumer experience that allows NFT minters to mint interesting generative NFT pieces on multi chains that respects the chain\u2019s unique designs and branding! ",
    ethereumAddress: "0xdb4a057C4054E030e6F04619777c17CafA33cf65",
    website: "https://github.com/jeff0723/multi-chain-mutation-nft",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1GeNNQtFNny07bu086YQj22eErwRk4VFq",
    logoCdnUrl:
      "https://drive.google.com/open?id=1h8MiiKHiFGaGaRzwCmbJnmnuaqv15DdC",
    bannerImageLink:
      "https://drive.google.com/open?id=1K5rso-x9PqXVPsFsM1db_3MQOGCldNyc",
    id: "17",
    recipientId: 17,
  },
  {
    Timestamp: "9/3/2023 13:05:35",
    projectName: "MooyAAho",
    tagline:
      "MuyAAho, voice ZK & Account Abstraction applied wallet which is secured by your voice.",
    description:
      "We focused on privacy problem.\nWhy does every transaction require the same security process even though the amount of money differ?\nMuyAAho suggests the Two-factor authentication based on the amount of money one tries to send.\nIt allows users to increase their own security.\n\nOne can set the threshold for when to add voice authentication when sending money.",
    ethereumAddress: "0x9f4f81832A8D552B51001D5cD97F195573deDE26",
    website:
      "https://github.com/half-gallon/aa , https://github.com/half-gallon/model , https://github.com/half-gallon/interface",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1nIPQk4XHn5LnNSGTMxHRiVltTrN09_ct",
    logoCdnUrl:
      "https://drive.google.com/open?id=1kHKh0Rs1Ubzmkkb6uu6_1e-0o89_rp28",
    bannerImageLink:
      "https://drive.google.com/open?id=1dPifzvlKDfLcTcpIuCb5YuZIr3GEsQ0G",
    id: "18",
    recipientId: 18,
  },
  {
    Timestamp: "9/3/2023 13:50:47",
    projectName: "Mandala : Ultimate Web3 Gaming Inventory",
    tagline:
      " game dev who is unfamiliar with web3 can easily create web3 games using the Mandala inventory. It provides the best advertising experience that will satisfy gamers, game devs and advertisers alike.",
    description:
      "The problem Mandala : Ultimate Web3 Gaming Inventory solves\nProblem\nAs depicted in the movie Ready Player One, we are looking forward to the activation of Web3 Gaming. However, there are two obstacles hindering its progress.\n\nPlayer Experience: Blockchain-based games may sometimes offer a less optimized user experience compared to traditional games. For example, additional steps may be required for transaction approvals or gas fees.\nTechnical Complexity: Blockchain and related technologies are complex and pose different challenges compared to the traditional game development process. Integrating these technologies requires new knowledge and expertise.\nWe solve this problem with an inventory created using ERC4337 and ERC6551.\n\nGame developers have a lot of things to consider. Additionally, learning and using Web3 technologies is a very difficult task.\nGame developers can easily convert their games into Web3 games by using the Mandala Inventory.\nGame developers have always wanted to use a well-made and customizable inventory system. If they can access Web3 by using the inventory without modifying the game logic, they will welcome it.\n\nBenefits\nThere are several benefits for game developers using the Mandala Inventory.\n\nMandala Inventories can interact with each other through trading, renting, auctioning, etc. There is no need to implement a trading system.\nProvides a new advertising experience that satisfies gamers, game developers, and advertisers alike.\nAdvertising Scenario\nCoca-Cola runs an advertisement. Coca-Cola sends Coca-Cola NFTs to the gamers' Mandala Inventory. The Coca-Cola NFT functions as an item in each game. Gamers have a good experience by receiving items that help them, rather than annoying advertisements. Game developers can easily insert advertisements without disrupting the game experience. Advertisers expose the advertisement every time a user opens their inventory, and the user does not feel annoyed.",
    ethereumAddress: "0xfa6Cc5134a2e81a2F19113992Ef61F9BE81cafdE",
    website: "https://github.com/EthconKorea2023/mandala",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1RlQ5kcJEOWC44WUz6rfBNCzRJiVFBTdX",
    logoCdnUrl:
      "https://drive.google.com/open?id=18lAU43Wk-8ar488N2EbmYzy5oiyIRd29",
    bannerImageLink:
      "https://drive.google.com/open?id=1E42zh9UxxD0wKMbDYeSV9u1-ZCGvU9VA",
    id: "19",
    recipientId: 19,
  },
  {
    Timestamp: "9/3/2023 12:15:29",
    projectName: "Handlit",
    tagline: "Telegram-Extended Trust-less Networking App",
    description:
      "Handlit elevates Web3 networking by simplifying the management of connections. It transforms fleeting encounters at events and conferences, often limited to Telegram exchanges, into meaningful and lasting connections",
    ethereumAddress: "0x512cEb57C6BCf86757C2693e729cBEE0AEa7Ffde",
    website: "https://github.com/orgs/handlit/repositories",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1GTYzNhJEopQBgneAt0xGQ9cKKFw-I0iJ",
    logoCdnUrl:
      "https://drive.google.com/open?id=1XXYp6XRzKj6xPPLpHqPIGa7GIo0Pfz0C",
    bannerImageLink:
      "https://drive.google.com/open?id=1D_2_C98c6PlSeV0ZKW-3i4ojQUOQB3z4",
    id: "20",
    recipientId: 20,
  },
  {
    Timestamp: "9/3/2023 13:43:21",
    projectName: "Vireo",
    tagline:
      "Vireo is a blockchain environmental project that wants to be the web3 greenpeace, collecting a sustainable investable treasury through delegate staking and proposing and voting on the use of funds through DAO membership, which is certified by VireoX (dynamic-NFT). ",
    description:
      'Overview\n"Vireo" is Latin for "green". Vireo is simply Web3.0 "GreenPeace". Vireo is a project that started with the belief that blockchain technology can help the environment.\n\nWe thought that the web3.0 POS validator activity would be a clue to sustainability. We set up a treasury with the yield from the validator and completed the structure by letting the DAO decide how to use the treasury for environmental activities.\n\nIn addition, DAO users can check their environmental impact in a visualized form and enjoy more environmental activities by obtaining VireoX creatures (Dynamic NFTs) that evolve in proportion to the amount of staking and the period of time.\n\nBackground\nIn 2023, the world was hit by an unprecedented climate crisis. As we were in the blockchain industry, we were inspired to start using blockchain to heal environmental problems.\n\nHow It Works\n1. Delegated Staking\nsmart contracts transparently direct generated interest into an environmental treasury.\nA real-time dashboard allows users to track how much is staked and accrued in the treasury.\n\n2. Decentralized Autonomous Organization (DAO)\nStakers are granted DAO memberships that allow them voting rights on how the treasury is utilized.\nDAO members can propose and vote on environmental initiatives.\n\n3. Dynamic NFTs (D-NFT)\nStakers receive D-NFTs as proof of membership.\nThese D-NFTs evolve based on the amount and duration of the stake, and they can grant additional voting power.',
    ethereumAddress: "0xB4fa1208E1f7dadA8a952B1EdeAdA26122024092",
    website: "https://github.com/CoredotLab/Vireo",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1qIY_z_KTLET_aA4WN28MhrK5_B9Pt9HT",
    logoCdnUrl:
      "https://drive.google.com/open?id=1iyPw9OK0fccWceKwVooj2qV9gEeUChA-",
    bannerImageLink:
      "https://drive.google.com/open?id=10u3nV8y-kglCKdh6PL3ION8acnEaY8vf",
    id: "21",
    recipientId: 21,
  },
  {
    Timestamp: "9/3/2023 12:45:46",
    projectName: "Transaction Hero",
    tagline:
      "Transaction Hero refunds gas fees to users by auctionizing the order flow market of block builders, solving the EOF problem through sharing the block builders' revenue.",
    description:
      "The problem Transaction Hero solves\n\nWhen PBS (Proposer-builder separation) settles down in the Ethereum ecosystem, block builders will further solidify their control over profit centralization through a mechanism known as Exclusive Order Flow (EOF). The emergence of builder profit centralization poses a significant challenge to Ethereum's fundamental principles, particularly in regard to issues such as censorship resistance and collusion.\nTransaction Hero offers a robust solution to address the issue of builder centralization that arises from EOF. This innovative platform introduces a strategic shift towards the open-marketization of Order Flow, effectively redistributing surplus profits generated from Order Flow to benefit the entire network.\nThrough Transaction Hero, users have the opportunity to earn a share of builder profits by directing their transactions to the platform. In return, builders can gain a competitive edge by acquiring Order Flow, which enables them to offer higher gas fees when submitting blocks. This symbiotic relationship fosters a more equitable and efficient Ethereum ecosystem while aligning with the network's core values.",
    ethereumAddress: "0x3254dd4C131edd9da829c5c151443BFE146609A4",
    website:
      "http://af6b378eedcca4bf189fac81647d7d7f-e676695616b25293.elb.ap-northeast-2.amazonaws.com/",
    thumbnailImageLink:
      "https://drive.google.com/open?id=164lvtrWx1m05ZE9NnmpoLYQC4ezIRze9",
    logoCdnUrl:
      "https://drive.google.com/open?id=1jZ-LeVa3_GCoLqtSyVeHlp7BHP4ZIXRI",
    bannerImageLink:
      "https://drive.google.com/open?id=1EL37Qi_zxadhV0GpFhxkNIt4UgxbjGn_",
    id: "22",
    recipientId: 22,
  },
  {
    Timestamp: "9/3/2023 12:43:38",
    projectName: "zkDraw",
    tagline: "A halo2 circuit verifies a linear congruential generator",
    description: "We made roulette-like game that you can trust using halo2.",
    ethereumAddress: "0xAEc69985145a65C5a749eE0F29A5Bc59B5cC3086",
    website: "https://github.com/jae-cuz/zk-draw",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1JYEdFIv8U6eomz5qoI7MnKBSbHxkg9o-",
    logoCdnUrl:
      "https://drive.google.com/open?id=1Rpm6wBR_r5yFDG7dm4Y-yFJ1Kj2ZIwxO",
    bannerImageLink:
      "https://drive.google.com/open?id=10jizi9r5evFE4j3VvQY95ztLrSJ0-S57",
    id: "23",
    recipientId: 23,
  },
  {
    Timestamp: "9/3/2023 14:38:22",
    projectName: "BUIDLersberg (Simperby)",
    tagline:
      "Decentralized Governance & Asset Clearance Chain that manages Across Blockchains",
    description:
      "A chain-agnostic yet decentralized governance infrastructure to manage assets across plethora of contracts dedicated to LP funds & DAOs",
    ethereumAddress: "0x856A1e9914ed608eE14626aC24aB61F1AB7f7A82",
    website: "https://github.com/Simperby-Ethcon/BUIDLersberg-Fund",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1xdONorGtmEixdzix-z7ypQQtwmuIRXxY",
    logoCdnUrl:
      "https://drive.google.com/open?id=1xQk-R3oj5oWfGdTXCNt7vH2nty9MR7x0",
    bannerImageLink:
      "https://drive.google.com/open?id=1rGCrEP9kGgTYsAJ81aO7ehvx5qGmhGT7",
    id: "24",
    recipientId: 24,
  },
  {
    Timestamp: "9/3/2023 15:52:00",
    projectName: "DEXperience",
    tagline: "A customized ERC4337 for derivatives dexs",
    description:
      " The simless account framework for cross-chain derivatives DEX based on ERC-4337",
    ethereumAddress: "0x5fe78311A41e83A1259AAB84B663bea7B56ea575",
    website: "https://github.com/orgs/ethcon-2023-liq/repositories",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1bebs-ctgmJGMxJaRqcPuhs5BaYPm3--l",
    logoCdnUrl:
      "https://drive.google.com/open?id=1G9wvQaHxusNwVqc8yiMivbiFMvyQSrsB",
    bannerImageLink:
      "https://drive.google.com/open?id=1rVLzcymfZbTl08WboHcng8RityI32EUj",
    id: "25",
    recipientId: 25,
  },
  {
    Timestamp: "9/3/2023 16:14:52",
    projectName: "ETHcation ",
    tagline: "This is dapp for learning blockchain theory for fully beginner",
    description:
      "Users can earn hearts (the in-game currency) by completing quizzes and missions. By implementing ERC-4337, we ensure that users are not burdened with gas fees when completing quests and obtaining NFT certificates.",
    ethereumAddress: "0x97b54C834A814aaeEAa8C1DBeD2512a18138C8Ad",
    website: "https://github.com/BPSEthcation",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1vR23l2PneZFJ0GJP8guXgDWB6ZD2TnsW",
    logoCdnUrl:
      "https://drive.google.com/open?id=1Xw-KzR15qky3IE3Np3pXQ5VzVl3GQ1zb",
    bannerImageLink:
      "https://drive.google.com/open?id=1mHGB9xoed0bbW8jPXfZa-jx-e8fs8o3N",
    id: "26",
    recipientId: 26,
  },
  {
    Timestamp: "9/3/2023 16:20:07",
    projectName: "Web3 Trans Wiki",
    tagline:
      "Aggregator/playground of translated web3 contents to track the contributors and offer social/financial reward which will solve the Language Barrier which can help accelerate the web3 mass addoption.",
    description:
      "[Problem] Approximately 95% of the global population does not use English as their primary language. This means that 95% of the population faces a language barrier that hinders their ability to properly learn the web3 ecosystem. It presents a significant obstacle to the mass adoption of web3.\n[Current Efforts/Limitation]\nFoundation/Team Directly hire a community manager for translation tasks but it\u2019s too slow to translate all the contents and often gets deprioritiezed by team.\nIndividuals in Ecosystem Voluntarily Translate English content into their respective native languages and upload on their blog and medium but the contents are scattered. And their effort is the form of contribution to the ecosystem but not it has not been recorded and there is no way to do that in web2.\n[Our Solution]\nPeople can search the original link of the project whether there is the translated version in their native language or not.\nIf there is no translation version for the original text, you can register as the main translator for that original contents and upload your translation.\nIf there is an existing translation without any significant issues, you can contribute by providing a better translation through comments.\nAfter a two-month period with no specific issues,both the main translator of the translation and those who provided comments can mint NFT, with each in the form of ERC-721 and ERC-1155 tokens respectively.\n[Expected Outcome] Contributors - because of the record of the contribution it can be social reward and NFTs can be utilized on a resume as web3 career/interest. Foundations/Teams - Much faster translation without centralized team resources and NFT(onchain data) can be used as a reference for future rewards such as airdrops for the genuine ecosystem contributors. Over All - More contributors for translation than the past and people can donate directly through the address of the contributors and lead to web3 mass adoption.",
    ethereumAddress: "0x2C8d1FD63aa75F1B8b5b2380dA75D7Ee333C6db0",
    website: "https://github.com/sanakang0615/TransWeb3",
    thumbnailImageLink:
      "https://drive.google.com/open?id=1njLnZipp-GU9drmttZDALRdhH8N1OC8B",
    logoCdnUrl:
      "https://drive.google.com/open?id=1SLjgFecX4uzJe4uq6AfLzG0knnGTVMEt",
    bannerImageLink:
      "https://drive.google.com/open?id=164bNajalipsBbLGaafsvOZ0BnIc-6vWA",
    id: "27",
    recipientId: 27,
  },
  {
    Timestamp: "9/3/2023 16:28:46",
    projectName: "Web3 Degen Challenge",
    tagline:
      "Habit-to-Earn platform that encourages the habit of trying out Web3 products. Users create challenges, stake their money, and if they succeed, they claim their collateral and that of others failed.",
    description:
      "-\tThe problem it solves\n\uf06e\tUsers have a desire to not only explore and contribute to the new ecosystem and product but also to receive airdrops in the process. However, generally, it's a hassle to go through this process alone. We are too lazy to do it. Also, crypto beginners face difficulties in understanding which products to use and how to utilize their features, even if they decide to use them. From the foundation/team's perspective, they hope for an increase in users voluntarily contributing to the ecosystem, ultimately aiming for penetration among the general public. However, this is not an easy task.\n\uf06e\tThere have been two existing efforts to address these issues. The first effort involves providing airdrops but it still have two issues. The first issue is that users are highly motivated before receiving the airdrop, but their motivation decreases once the airdrop ends. Another related issue is that the airdrop can lead to cherry-picking. From the viewpoint of the foundation/team, the motivation behind airdrops is contrary to the hope that the ecosystem becomes more active when launching the actual mainnet/product compared to the testnet. Secondly, similar services like Layer3 and node guardians exist to address these issues. But they also face two main challenges. They reward with their native points, but without clear utility for these points, it may not provide sufficient motivation. Because the team centrally creates quests, the quest creation speed is relatively slow, and products from teams that have not commissioned quests cannot be tried.\n\n-\tOur solution\n\uf06e\tIntroducing Habit-to-Earn, the Web3 Degen Challenge, a platform that encourages the habit of trying out various new products in the Web3 world. Users create their own challenges, stake their money, and if they succeed, they claim their collateral and that of others failed. \n\uf06e\tIn the South Korean Web2 industry, there already exists a service called 'Challengers.\u201d In this service, individuals stake their own money and complete various certification and mission tasks to cultivate good habits. The average success rate for these challenges is reported to be only 50%.\n\uf06e\tUser flow: Connect Wallet > Select the challenge you want to participate in > Place a deposit > After completing the mission, click 'Check Availability\u2019 > If succeed, receive your deposit back > Upon completion, receive your entire deposit and a portion of the deposits from mission failures ",
    ethereumAddress: "0x92E80d9d9214F5fbe6Ea5B46fD0E86BDd24092eD",
    website: "https://github.com/Violet-Bora-Lee/web3-degen-challenge",
    thumbnailImageLink:
      "https://drive.google.com/open?id=12pubwXOxX30CBsJrqVnmTgsAhtYnurIy",
    logoCdnUrl:
      "https://drive.google.com/open?id=1mzQxjYILFsd5PxC1Ag0NZ0rK4_fyea1V",
    bannerImageLink:
      "https://drive.google.com/open?id=1_b7hfE8ZNSvYC6vYrwZdbkwXbiSD5YqG",
    id: "28",
    recipientId: 28,
  },
];

export function getProjects() {
  return projects;
}

export function getRecipientIdbyId(id) {
  console.log(id);
  const p = projects.find((p) => p.id === id);

  return p.recipientId;
}

export function getProject(id: string) {
  return (
    projects.find((p) => p.id === id) ?? {
      projectName: "404 Project not found",
      tagline: "404 Tagline not found",
      description: "404 Description not found",
      ethereumAddress: "404 Address not found",
      website: "404 URL not found",
      thumbnailImageLink: "https://source.unsplash.com/random",
      logoCdnUrl: "https://source.unsplash.com/random",
      bannerImageLink: "https://source.unsplash.com/random",
      recipientId: 0,
      id: "0",
    }
  );
}

function shuffleFisherYates(array: any) {
  let i = array.length;
  while (i--) {
    const ri = Math.floor(Math.random() * i);
    [array[i], array[ri]] = [array[ri], array[i]];
  }
  return array;
}

//return shuffled version of allprojects array
export function getShuffledProjects() {
  return shuffleFisherYates(getProjects());
}
